import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { apiClient } from '../utils/apiClient';
import { ApiError } from './errors';

type ApiInit = NonNullable<Parameters<typeof apiClient.get>[2]>;

export type KitchenApiArgs = {
    apiName: 'brunch' | 'brunch-v2';
    path: string;
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    body?: ApiInit['body'];
    headers?: Record<string, string>;
    queryParams?: Record<string, string>;
};

export const kitchenBaseQuery: BaseQueryFn<
    KitchenApiArgs,
    unknown,
    ApiError
> = async ({ apiName, path, method = 'GET', body, headers, queryParams }) => {
    try {
        const init = { body, headers, queryParams };
        let data: unknown;

        switch (method) {
            case 'GET':
                data = await apiClient.get(apiName, path, init);
                break;
            case 'POST':
                data = await apiClient.post(apiName, path, init);
                break;
            case 'PUT':
                data = await apiClient.put(apiName, path, init);
                break;
            case 'PATCH':
                data = await apiClient.patch(apiName, path, init);
                break;
            case 'DELETE':
                data = await apiClient.del(apiName, path, init);
                break;
        }

        return { data };
    } catch (error) {
        if (error instanceof ApiError) {
            return { error };
        }
        return {
            error: new ApiError(
                500,
                error instanceof Error ? error.message : 'Unknown error'
            )
        };
    }
};
